import React, { ReactNode } from "react";
import { Form } from "antd";
import { FieldProps } from "formik";

type Props = FieldProps & { children: ReactNode };
export const FormField = ({
  children,
  field,
  form: { touched, errors },
}: Props) => {
  return (
    <Form.Item
      style={{ marginBottom: 16 }}
      validateStatus={
        touched[field.name] && errors[field.name] ? "error" : undefined
      }
      help={touched[field.name] && errors[field.name]}
    >
      {children}
    </Form.Item>
  );
};
